import { defaultCheckError, progressEpic } from "epics/base-epic";
import { ATS_EXPORT } from "constants/action-types";
import { IAddRowActionPayload } from "actions/ats-custom-template-actions";
import { buildFetchParams } from "helpers/epics";

export const initiateExportEpic = progressEpic<IAddRowActionPayload, never>(
    ATS_EXPORT.INITIATE,
    buildFetchParams("POST"),
    {
        checkErrorStatus: defaultCheckError,
    },
);
